import React from "react";
import About from "./../workspaces/About/About";
import { Shell } from "@informatica/droplets-core";
import "@informatica/droplets-core/dist/themes/archipelago/archipelago.css";
import GlassRoutes from "../../GlassRoutes";
const Layout = props => {
  return (
    <Shell>
      <Shell.Header productName="Operational Insights" />
      <GlassRoutes>
        {/* <About key="about" {...About.workspaceConfig} /> */}
      </GlassRoutes>
    </Shell>
  );
};

export default Layout;
